import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";

export const responsiveDimension = (xs, sm, md, lg, xl) => {
  return { xs, sm, md, lg, xl };
};

export const ScreenDimension = () => {
  const theme = useTheme();
  const XS = useMediaQuery(theme.breakpoints.up("xs"));
  const XSM = useMediaQuery(theme.breakpoints.up("xsm"));
  const SM = useMediaQuery(theme.breakpoints.up("sm"));
  const SMD = useMediaQuery(theme.breakpoints.up("smd"));
  const MD = useMediaQuery(theme.breakpoints.up("md"));
  const MLG = useMediaQuery(theme.breakpoints.up("mlg"));
  const LG = useMediaQuery(theme.breakpoints.up("lg"));
  const LXL = useMediaQuery(theme.breakpoints.up("lxl"));
  const XL = useMediaQuery(theme.breakpoints.up("xl"));
  return { XS, XSM, SM, SMD, MD, MLG, LG, LXL, XL };
};

export const ResponsiveStyles = (styles) => {
  const breakpointsStyles = {};

  const theme = useTheme();
  Object.keys(styles).forEach((property) => {
    const values = styles[property];
    Object.keys(values).forEach((breakpoint) => {
      const style = {
        [property]: values[breakpoint],
      };

      breakpointsStyles[theme.breakpoints.up(breakpoint)] = {
        ...(breakpointsStyles[theme.breakpoints.up(breakpoint)] || {}),
        ...style,
      };
    });
  });
  return breakpointsStyles;
};
